var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapMarkerPinYoubike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m20.998 36.341-.998.872-.998-.872C10.61 29.013 6.344 22.614 6.344 16.99 6.344 9.025 12.56 3.334 20 3.334s13.657 5.69 13.657 13.656c0 5.624-4.266 12.023-12.659 19.351z",
    fill: "#0C9F2C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m20 39.425-2.094-1.829C9.483 30.242 4.676 23.408 4.676 16.99 4.677 8.061 11.683 1.666 20 1.666c8.317 0 15.323 6.395 15.323 15.322 0 6.419-4.806 13.253-13.229 20.607L20 39.426zm0-2.212.998-.872c8.392-7.328 12.658-13.727 12.658-19.352C33.656 9.024 27.44 3.333 20 3.333c-7.44 0-13.657 5.691-13.657 13.656 0 5.625 4.266 12.024 12.659 19.352l.998.871z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 17,
    r: 10,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)",
    fill: "#B0C81C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.792 14.052c.191-.31.55-.477.896-.585a2.14 2.14 0 0 0-.37.442.82.82 0 0 0-.156.406c-.071.31.024.609.18.895a1.131 1.131 0 0 1-.347-.084c-.382-.155-.394-.752-.203-1.074zm2.71-.179a1.05 1.05 0 0 0-.25-.143.72.72 0 0 0-.06-.287c.023.012.06.024.083.036a.45.45 0 0 1 .227.394zm-.99-.215c-.084-.024-.168-.047-.263-.047.06-.024.107-.048.167-.072.131-.036.322-.024.394.107-.096-.012-.191 0-.299.012zm.047.537v.12l-.024.071a1.073 1.073 0 0 1-.155.31c-.084 0-.155 0-.227-.011-.095 0-.215-.024-.322-.06.024-.107.095-.215.239-.322.119-.084.25-.155.393-.191.048.024.072.06.096.083zm-.92 1.445c.06.083.12.143.18.215.19.203.525-.084.322-.287l-.024-.036c.096-.036.191-.071.287-.12.215-.095.441-.226.633-.405.584-.227 1.062-.74.835-1.468-.287-.895-1.707-.692-2.328-.49-.501.156-1.026.466-1.217 1.003-.191.573-.024 1.194.477 1.48.251.132.55.155.836.108zM25.083 15.126c-.381-.155-.393-.752-.202-1.074.19-.31.56-.477.907-.585a1.88 1.88 0 0 0-.382.442.797.797 0 0 0-.143.406c-.084.31.011.62.167.895a1.132 1.132 0 0 1-.347-.084zm2.507-1.253a1.05 1.05 0 0 0-.25-.143.562.562 0 0 0-.06-.287c.024.012.06.024.083.036a.45.45 0 0 1 .227.394zm-.99-.215a.607.607 0 0 0-.263-.047c.06-.024.12-.048.167-.072.131-.036.322-.036.394.107-.096-.012-.191 0-.299.012zm.035.537c.024.048.024.084.024.12l-.036.071a.797.797 0 0 1-.167.31c-.072 0-.143 0-.215-.011a1.16 1.16 0 0 1-.322-.06c.024-.107.096-.215.239-.322.107-.084.25-.155.406-.191.035.024.06.06.071.083zm.49.812c.584-.227 1.074-.74.835-1.468-.286-.895-1.695-.692-2.328-.49-.489.168-1.026.466-1.217 1.003-.191.573-.024 1.206.49 1.48.25.132.537.155.823.108.072.071.131.143.191.215.191.203.513-.084.322-.287l-.035-.036c.095-.036.19-.071.286-.12a2.28 2.28 0 0 0 .633-.405zM24.977 17.464h-.036a.539.539 0 0 0-.49.454c-.011.047 0 .024-.011.071-.275 2.006-1.528 3.474-3.342 4.107-1.612.56-3.581.358-4.942-.753-1.086-.883-1.409-2.303-1.206-3.688.048-.298-.322-.43-.525-.37a.477.477 0 0 0-.334.239 1.65 1.65 0 0 0-.12.394c-.298 1.97.585 3.736 2.233 4.643 1.635.92 3.664 1.038 5.43.466 2.066-.68 3.653-2.376 3.856-4.715v-.084c.024-.525-.226-.764-.513-.764z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(13.25 12.875)",
    d: "M0 0h14.772v10.5H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: -3,
    y: -1,
    width: 46,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarkerPinYoubike);
export default __webpack_public_path__ + "static/media/map-marker-pin-youbike.c0f5e1a9e929f0045467d548989d0c08.svg";
export { ForwardRef as ReactComponent };